var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewBoardsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.3333V4.66666M6 11.3333C6 11.6869 5.85952 12.0261 5.60948 12.2761C5.35943 12.5262 5.02029 12.6667 4.66667 12.6667H3.33333C2.97971 12.6667 2.64057 12.5262 2.39052 12.2761C2.14048 12.0261 2 11.6869 2 11.3333V4.66666C2 4.31304 2.14048 3.9739 2.39052 3.72385C2.64057 3.4738 2.97971 3.33333 3.33333 3.33333H4.66667C5.02029 3.33333 5.35943 3.4738 5.60948 3.72385C5.85952 3.9739 6 4.31304 6 4.66666M6 11.3333C6 11.6869 6.14048 12.0261 6.39052 12.2761C6.64057 12.5262 6.97971 12.6667 7.33333 12.6667H8.66667C9.02029 12.6667 9.35943 12.5262 9.60948 12.2761C9.85952 12.0261 10 11.6869 10 11.3333M6 4.66666C6 4.31304 6.14048 3.9739 6.39052 3.72385C6.64057 3.4738 6.97971 3.33333 7.33333 3.33333H8.66667C9.02029 3.33333 9.35943 3.4738 9.60948 3.72385C9.85952 3.9739 10 4.31304 10 4.66666M10 11.3333V4.66666M10 11.3333C10 11.6869 10.1405 12.0261 10.3905 12.2761C10.6406 12.5262 10.9797 12.6667 11.3333 12.6667H12.6667C13.0203 12.6667 13.3594 12.5262 13.6095 12.2761C13.8595 12.0261 14 11.6869 14 11.3333V4.66666C14 4.31304 13.8595 3.9739 13.6095 3.72385C13.3594 3.4738 13.0203 3.33333 12.6667 3.33333H11.3333C10.9797 3.33333 10.6406 3.4738 10.3905 3.72385C10.1405 3.9739 10 4.31304 10 4.66666",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBoardsOutline);
export default __webpack_public_path__ + "static/media/ViewBoardsOutline.5bbaeec3c91aae407c4dd04e05dd5b71.svg";
export { ForwardRef as ReactComponent };